import React, { useRef } from "react";
import { Col, Row, Button, InputGroup, InputGroupText, Input } from "reactstrap";
import moment from "moment";
import { FaFilter, FaTimes } from "react-icons/fa";
import { createFilter } from "react-select";
import DateRangePicker from "../../../sharedComponents/DateRangePicker/DateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import useDataSuite from "../useDataSuite";
import { useEffect, useState } from "react";
import { selectStyles, Theme } from "../../../config/constants";
import {
    clearDataSuiteFilters,
    setDataSetsDetailsFilter,
    setDataSetsFilter
} from "../../../reducers/DatasuiteReducer/DataSuiteActions";
import { BsSearch } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import SelectAllSearch from "../../../sharedComponents/Select/SelectAllSearch";
import Select from "react-select";
import { DropdownIndicator, ValueContainer } from "../../../config/customSelect";

const FiltersCard = (props) => {
    const fromDate = useSelector(({dates}) => dates.datasuiteFromDate);
    const toDate = useSelector(({dates}) => dates.datasuiteToDate);
    const detailsFromDate = useSelector(({dates}) => dates.datasuiteDetailsFromDate);
    const detailsToDate = useSelector(({dates}) => dates.datasuiteDetailsToDate);
    const minDate = useSelector(({dates}) => dates.datasuiteMinDate);
    const detailsMinDate = useSelector(({dates}) => dates.datasuiteDetailsMinDate);
    const allFilters = useSelector(({datasuite}) => datasuite.allFilters);
    const selectedFilters = useSelector(({datasuite}) => datasuite.selectedFilters);
    const selectedDetailsFilters = useSelector(({datasuite}) => datasuite.selectedDetailsFilters);
    const { clickMoreFilters, filtersDrawerOpen, getFilters, setSelectedDataSets, setSelectedCategories, setSelectedDistributors, setSelectedLocations, setSelectedSegments, setSelectedStates, setSelectedChildren, changeDataSuiteDates,
            setIncludedSearchKeywords, setExcludedSearchKeywords, removeIncludedSearchKeyword, removeExcludedSearchKeyword } = useDataSuite.useDataSuite();
    const parentElement = props.parentElement ? props.parentElement : '';
    const chainData = useSelector(({user}) => user.chainData);
    const emergingData = useSelector(({user}) => user.emergingData);
    const widgetDetailsDrawerContents = useSelector(({datasuite}) => datasuite.widgetDetailsDrawer);
    const defaultDatasetsLoaded = useSelector(({datasuite}) => datasuite.defaultDatasetsLoaded);
    const [showClearButton, setShowClearButton] = useState(false);
    const [selectedDataSets] = useState(false);
    const detailView = parentElement === 'Details' || parentElement === 'DetailsPage';
    const dateRef = useRef();
    const searchOptionsRef = useRef();
    const dispatch = useDispatch();
    const selectedManufacturers = useSelector(({user}) => user.selectedManufacturers);

    const removeIncludedSearchTag = (removedTag) => {
        removeIncludedSearchKeyword(removedTag);
    }

    const removeExcludedSearchTag = (removedTag) => {
        removeExcludedSearchKeyword(removedTag);
    }

    const includedSearchTagsMap = selectedDetailsFilters?.includedSearch?.map((tag, index) => {
        return (
            <div key={index} className="w-fc me-1 px-2 py-1" style={{background: "#49A4DA", color: "white", borderRadius: '5px'}}>
                {tag}
                <IoIosClose className="ms-1 clickable" fontSize={"24px"} onClick={() => removeIncludedSearchTag(tag)} />
            </div>
        );
    });

    const excludedSearchTagsMap = selectedDetailsFilters?.excludedSearch?.map((tag, index) => {
        return (
            <div key={index} className="w-fc me-1 px-2 py-1" style={{background: Theme().colors.accent, color: "white", borderRadius: '5px'}}>
                {tag}
                <IoIosClose className="ms-1 clickable" fontSize={"24px"} onClick={() => removeExcludedSearchTag(tag)} />
            </div>
        );
    });

    const categoriesOptionsMap = detailView ?
    allFilters?.categories?.sort().sort((a,b) => selectedDetailsFilters?.categories?.includes(b) - selectedDetailsFilters?.categories?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    }) :
    allFilters?.categories?.sort().sort((a,b) => selectedFilters?.categories?.includes(b) - selectedFilters?.categories?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const selectedCategoriesMap = selectedFilters?.categories?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedCategoriesDetailsMap = selectedDetailsFilters?.categories?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedOperatorsMap = selectedFilters?.locations?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedOperatorsDetailsMap = selectedDetailsFilters?.locations?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const distributorOptionsMap = detailView ?
    allFilters?.distributors?.sort().sort((a,b) => selectedDetailsFilters?.distributors?.includes(b) - selectedDetailsFilters?.distributors?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    }) :
    allFilters?.distributors?.sort().sort((a,b) => selectedFilters?.distributors?.includes(b) - selectedFilters?.distributors?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const selectedDistributorsMap = selectedFilters?.distributors?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedDistributorsDetailsMap = selectedDetailsFilters?.distributors?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const segmentOptionsMap = detailView ? allFilters?.segments?.sort().sort((a,b) => selectedDetailsFilters?.segments?.includes(b) - selectedDetailsFilters?.segments?.includes(a)).map((data) => {
        const segmentLabel = data.split('_').map(w => w[0].toUpperCase() + w.substring(1).toLowerCase()).join(' ');
        return (
            {value: data, label: segmentLabel}
        );
    }) :
    allFilters?.segments?.sort().sort((a,b) => selectedFilters?.segments?.includes(b) - selectedFilters?.segments?.includes(a)).map((data) => {
        const segmentLabel = data.split('_').map(w => w[0].toUpperCase() + w.substring(1).toLowerCase()).join(' ');
        return (
            {value: data, label: segmentLabel}
        );
    });

    const selectedSegmentsMap = selectedFilters?.segments?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedSegmentsDetailsMap = selectedDetailsFilters?.segments?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const stateOptionsMap = detailView ? allFilters?.states?.sort().sort((a,b) => selectedDetailsFilters?.states?.includes(b) - selectedDetailsFilters?.states?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    }) :
    allFilters?.states?.sort().sort((a,b) => selectedFilters?.states?.includes(b) - selectedFilters?.states?.includes(a)).map((data) => {
        return (
            {value: data, label: data}
        );
    });

    const selectedStatesMap = selectedFilters?.states?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    const selectedStatesDetailsMap = selectedDetailsFilters?.states?.map((data) => {
        return (
            {value: data, label: data}
        )
    });

    //const selectedOperatorNames = detailView ? selectedOperatorsDetailsMap?.map(loc => loc.value) : selectedOperatorsMap?.map(loc => loc.value);
    //const selectedSegments = detailView ? selectedSegmentsDetailsMap?.map(segment => segment.value) : selectedSegmentsMap?.map(segment => segment.value);

    // // Show all locations if no segment is selected
    let filteredLocations = allFilters?.locations;

    // if (selectedSegments?.length > 0) {
    //     if (selectedOperatorNames?.length > 0) {
    //         // Show 1.) locations in the selected segments 2.) selected locations
    //         filteredLocations = allFilters?.locations?.filter((loc) =>
    //             selectedSegments.includes(loc.market_segment) || selectedOperatorNames.includes(loc.location_name)
    //         );
    //     }
    //     else {
    //         // Show only locations in the selected segments
    //         filteredLocations = allFilters?.locations?.filter((loc) =>
    //             selectedSegments.includes(loc.market_segment)
    //         );
    //     }
    // }

    const operatorOptionsMap = detailView ?  filteredLocations?.sort((a, b) => a.localeCompare(b)).sort((a,b) => selectedDetailsFilters?.locations?.includes(b) - selectedDetailsFilters?.locations?.includes(a))
        .map((data) => {
            return (
                {value: data, label: data}
            );
    }) :
    filteredLocations?.sort((a, b) => a.localeCompare(b)).sort((a,b) => selectedFilters?.locations?.includes(b) - selectedFilters?.locations?.includes(a))
        .map((data) => {
            return (
                {value: data, label: data}
            );
    });

    const selectedChildrenMap = (detailView ? selectedDetailsFilters?.children : selectedFilters?.children)?.map((name) => ({ value: name, label: name })) || [];
    const selectedChildrenDetailsMap = selectedDetailsFilters?.children?.map((name) => ({ value: name, label: name })) || [];

 const childrenFromStore = Array.isArray(allFilters) ? (allFilters[0]?.children || []) : (allFilters?.children || []);

 const childrenOptionsMap = (childrenFromStore || []).slice().sort().map((name) => ({ value: name, label: name }));

    const datasetOptions = [
        {
            value: "Chain Data",
            label: "Chain Data",
            isDisabled: !chainData
        },
        {
            value: "Emerging Chain Data",
            label: "Emerging Chain Data",
            isDisabled: !emergingData
        }
    ];

    const searchOptions = [
        {
            value: "Include",
            label: "Include",
            isDisabled: false
        },
        {
            value: "Exclude",
            label: "Exclude",
            isDisabled: false
        }
    ];

    const selectedDatasetsMap = [];
    const selectedDatasetsDetailsMap = [];
    if (selectedFilters?.chainData) {
        selectedDatasetsMap.push(datasetOptions[0]);
    }
    if (selectedFilters?.gpoData) {
        selectedDatasetsMap.push(datasetOptions[1]);
    }
    if (selectedDetailsFilters?.chainData) {
        selectedDatasetsDetailsMap.push(datasetOptions[0]);
    }
    if (selectedDetailsFilters?.gpoData) {
        selectedDatasetsDetailsMap.push(datasetOptions[1]);
    }

    const initializePage = () => {
        getFilters();
        if (!defaultDatasetsLoaded) {
            dispatch(setDataSetsFilter(chainData, emergingData));
            dispatch(setDataSetsDetailsFilter(chainData, emergingData));
        }
    }

    const handleClearFilters = () => {
        setSelectedCategories();
        setSelectedLocations();
        setSelectedDistributors();
        setSelectedSegments();
        setSelectedChildren();
        setExcludedSearchKeywords();
        setIncludedSearchKeywords();
      };

    const addSearchKeyword = (e) => {
        if(e.keyCode === 13) {
            if(searchOptionsRef?.current.state.selectValue[0].value === "Include") {
                setIncludedSearchKeywords(e.target.value, detailView);
                e.target.value="";
            }
            if(searchOptionsRef?.current.state.selectValue[0].value === "Exclude") {
                setExcludedSearchKeywords(e.target.value, detailView);
                e.target.value="";
            }
        }
    };

    const handleSearchManufacturer = () => {
        handleClearFilters();
        dispatch(clearDataSuiteFilters());
    }

    useEffect( () => {
        if (allFilters?.length === 0) {
            initializePage();
        }
    // eslint-disable-next-line
    }, [allFilters]);

    // eslint-disable-next-line
    useEffect(handleSearchManufacturer, [selectedManufacturers]);

    useEffect(() => {
        const hasFilters = Object.values(selectedFilters).some((filter) => filter && filter.length > 0) || (selectedDataSets.length > 0 && selectedDataSets[0] !== null)
                            || Object.values(selectedDetailsFilters).some((filter) => filter && filter.length > 0);
        setShowClearButton(hasFilters);
    }, [selectedFilters, selectedDetailsFilters, selectedDataSets]);

    // The daterange component we use is uncontrolled, so we must save a ref
    // to this component and update the selected values on our own. This is
    // only applicable to the details date range as its value can be updated by
    // other components.
    useEffect(() => {
        if (detailView) {
            dateRef.current?.setStartDate(moment(detailsFromDate).format('MM/DD/YYYY'));
            dateRef.current?.setEndDate(moment(detailsToDate).format('MM/DD/YYYY'));
        }
    }, [detailView, detailsFromDate, detailsToDate]);

    return (
        <Col className="h-100">
            <Row id={`filters${parentElement}Main`} className="w-100 mx-0" style={{ textWrap: 'nowrap', background: 'white', backgroundImage: 'url("./FiltersBackground.png")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', zIndex: '2', position: 'relative', borderRadius: '5px'}}>
                <Col>
                    <Row className="px-3 pt-2" style={{position: 'relative'}}>
                        <Col>
                            <Row>
                                <div className="main-header text-size-20" style={{color: '#00A6CC'}}><FaFilter fontSize={'15px'} style={{marginBottom: '5px'}}/> Filters</div>
                            </Row>
                            <Row>
                            {widgetDetailsDrawerContents.title === "Sales Void Opportunities" ? (
                                <Row>
                                    <div className="main-header text-size-14">Use the filters below to narrow your search. For best results in this report, select a category first.</div>
                                </Row>
                            ) : (
                                <Row>
                                    <div className="main-header text-size-14">Use the filters below to narrow your search.</div>
                                </Row>
                            )}
                            </Row>
                            <Row className="mb-2" style={{'--bs-gutter-y': '8px'}}>
                                {parentElement === "DetailsPage" &&
                                    <Col style={{minWidth: '300px', whiteSpace: 'nowrap'}}>
                                        <InputGroup className='ps-0' size='md'>
                                            <InputGroupText>
                                                <BsSearch/>
                                            </InputGroupText>
                                            <Input className='text-input' id={`datasuite${parentElement}SearchInput`} placeholder='Search...' onKeyUp={(e) => addSearchKeyword(e)}/>
                                            <Select
                                                style={{minWidth: '160px'}}
                                                isMulti={false}
                                                ref={searchOptionsRef}
                                                id={`datasuite${parentElement}SearchOptions`}
                                                name='searchChoice'
                                                options = {searchOptions}
                                                defaultValue={searchOptions[0]}
                                                styles={selectStyles}
                                                components={{DropdownIndicator, ValueContainer}}
                                            />
                                        </InputGroup>
                                    </Col>
                                }
                                <Col className="col-4" style={{minWidth: '200px'}}>
                                    <DateRangePicker 
                                        childRef={dateRef}
                                        id={`dataSuite${parentElement}DateSearch`}
                                        defaultStartDate={moment(detailView ? detailsFromDate : fromDate).format('MM/DD/YYYY')}
                                        defaultEndDate={moment(detailView ? detailsToDate : toDate).format('MM/DD/YYYY')}
                                        minDate={moment(detailView ? detailsMinDate : minDate).format('MM/DD/YYYY')}
                                        maxDate={moment().format('MM/DD/YYYY')}
                                        callback={(start, end) => changeDataSuiteDates(start, end, detailView)}
                                        ranges={
                                        {
                                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                        'Last 2 Months': [moment().subtract(2, 'month'), moment()],
                                        'Last Year': [moment().subtract(1, 'year'), moment()]
                                        }
                                        }
                                    />
                                </Col>
                                <Col className="col-4" style={{minWidth: '200px'}}>
                                    <SelectAllSearch
                                        isMulti
                                        name='dataSet'
                                        options = {datasetOptions}
                                        onChange = {(e) => setSelectedDataSets(e, detailView)}
                                        value = {detailView ? selectedDatasetsDetailsMap : selectedDatasetsMap}
                                        placeholder='Select Data Set'
                                    />
                                </Col>
                                <Col className="col-4" style={{minWidth: '200px'}}>
                                    <SelectAllSearch 
                                        isMulti
                                        filterOption={createFilter({ ignoreAccents: false })}
                                        name='category'
                                        options = {categoriesOptionsMap}
                                        onChange = {(e) => setSelectedCategories(e, detailView)}
                                        value = {detailView ? selectedCategoriesDetailsMap : selectedCategoriesMap}
                                        placeholder='Select Category'
                                    />
                                </Col>
                                {!detailView &&
                                <Col className="col-4" style={{minWidth: '200px'}}>
                                    <SelectAllSearch 
                                        isMulti
                                        name='operator'
                                        options = {operatorOptionsMap}
                                        onChange = {(e) => setSelectedLocations(e, detailView)}
                                        value = {detailView ? selectedOperatorsDetailsMap : selectedOperatorsMap}
                                        placeholder='Select Parent Location(s)'
                                    />
                                </Col>
                                }
                                {!detailView &&
                                <Col className="col-4" style={{minWidth: '200px'}}>
                                    <SelectAllSearch
                                    isMulti
                                    name='children'
                                    options={childrenOptionsMap}
                                    onChange={(e) => setSelectedChildren(e, false)}
                                    value={selectedChildrenMap}
                                    placeholder='Select Child Location(s)'
                                    isDisabled={selectedFilters?.locations?.length === 0}
                                    />
                                </Col>
                                }
                            </Row>
                            <Row className="mb-2" style={{'--bs-gutter-y': '8px', justifyContent: 'center'}}>
                                <Col style={{minWidth: '200px', maxWidth: '400px'}}>
                                    <Button 
                                        block 
                                        id="moreFiltersButton"
                                        className='py-2 button-label'
                                        size='sm'
                                        style={{width: '120px'}}
                                        color='blueFilter'
                                        onClick={() => clickMoreFilters(parentElement)}
                                    >
                                    {!filtersDrawerOpen &&
                                    <span style={{fontWeight: '600', color: 'white'}}><FaFilter fontSize={'16px'}/> More Filters</span>
                                    }
                                    {filtersDrawerOpen &&
                                    <span style={{fontWeight: '600', color: 'white'}}><FaTimes fontSize={'18px'} style={{marginBottom: '2px'}}/> Hide Filters</span>
                                    }
                                    </Button>
                                </Col>
                                {showClearButton && 
                                <Col style={{minWidth: '200px', maxWidth: '400px'}}>
                                    <Button
                                        outline={true}
                                        block
                                        id="clearFiltersButton"
                                        className="py-2 button-label"
                                        size="sm"
                                        style={{ width: "100px" }}
                                        color='blueFilter'
                                        onClick={handleClearFilters}>
                                        <span style={{fontWeight: '600'}}>Clear Filters</span>
                                    </Button>
                                </Col>
                                }
                            </Row>
                            {((selectedDetailsFilters?.includedSearch?.length > 0 || selectedDetailsFilters?.excludedSearch?.length > 0) && parentElement === "DetailsPage") &&
                                <Row style={{minWidth: '200px'}}>
                                    <Col className="col-12 mx-2" style={{display: 'flex', padding: '2px', borderRadius: '5px', background: 'white'}}>
                                        {includedSearchTagsMap}
                                        {excludedSearchTagsMap}
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row id={`filters${parentElement}Drawer`} className="mx-0 py-2 px-3 w-100" style={{ textWrap:'nowrap', borderRadius: '0px 0px 5px 5px', background: 'lightgrey', display: 'none', '--bs-gutter-y':'8px'}}>
                {detailView && 
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch 
                        isMulti
                        name='operator'
                        options = {operatorOptionsMap}
                        onChange = {(e) => setSelectedLocations(e, detailView)}
                        value = {detailView ? selectedOperatorsDetailsMap : selectedOperatorsMap}
                        placeholder='Select Parent Location(s)'
                    />
                </Col>
                }
                {detailView &&
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch
                    isMulti
                    name='children'
                    options={detailView ? (Array.isArray(allFilters?.children) ? allFilters.children : []).map((name) => ({ value: name, label: name })) : childrenOptionsMap}
                    onChange={(e) => setSelectedChildren(e, true)}
                    value={selectedChildrenDetailsMap}
                    placeholder='Select Child Location(s)'
                    isDisabled={selectedDetailsFilters?.locations?.length === 0}
                    />
                </Col>
                }
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch 
                        isMulti
                        name='distributor'
                        options = {distributorOptionsMap}
                        onChange = {(e) => setSelectedDistributors(e, detailView)}
                        value = {detailView ? selectedDistributorsDetailsMap : selectedDistributorsMap}
                        placeholder='Select Distributor'
                    />
                </Col>
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch 
                        classNamePrefix="custom-select "
                        isDisabled={true}
                        name='location'
                        placeholder='Select Distribution Center Location'
                    />
                </Col>
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch 
                        isMulti
                        name='customer'
                        options = {segmentOptionsMap}
                        onChange = {(e) => setSelectedSegments(e, detailView)}
                        value = {detailView ? selectedSegmentsDetailsMap : selectedSegmentsMap}
                        placeholder='Select Customer Segment'
                    />
                </Col>
                <Col className="col-4" style={{minWidth: '200px'}}>
                    <SelectAllSearch 
                        isMulti
                        name='state'
                        options = {stateOptionsMap}
                        onChange = {(e) => setSelectedStates(e, detailView)}
                        value = {detailView ? selectedStatesDetailsMap : selectedStatesMap}
                        placeholder='Select State'
                    />
                </Col>
            </Row>
        </Col>
    )
}

export default FiltersCard;
